var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingLoopShortRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 80,
    viewBox: "0 0 114 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.416,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 113.416 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.082,
    cy: 40.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9273 51.999H72.3273V38.199C72.3273 34.799 72.3273 27.399 62.0773 27.399C58.2773 27.399 54.5273 28.549 51.8773 31.249L55.0273 34.399C56.6273 32.899 58.9273 31.899 61.4273 31.899C64.6273 31.899 66.9273 33.449 66.9273 36.399V37.049H65.4273C59.4273 37.049 50.3273 37.599 50.3273 45.399C50.3273 50.149 54.6273 52.599 59.0773 52.599C62.2773 52.599 65.0773 51.399 66.7773 48.699H66.9273V51.999ZM66.5773 42.599C66.5773 45.949 64.6273 48.099 60.5273 48.099C58.5773 48.099 56.3273 47.149 56.3273 44.949C56.3273 41.499 62.0273 41.249 65.3273 41.249H66.5773V42.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7.86133,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 7.86133)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17.8613,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 17.8613)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27.8613,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 27.8613)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 37.8613,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 37.8613)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 47.8613,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 47.8613)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 57.8613,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 57.8613)",
    fill: "#52B3A7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 67.8613,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14 67.8613)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingLoopShortRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-loop-short-right.fcbd08f996303a6a7ea9cded8c181899.svg";
export { ForwardRef as ReactComponent };